import { http } from '@/api/client/httpClient';
import type { ApplicationConfiguration } from '@/api/types/abp';

// Standard ABP endpoint carrying currentUser, granted policies, current tenant
// and localization. Loaded once after authentication.
export async function getApplicationConfiguration(): Promise<ApplicationConfiguration> {
  const { data } = await http.get<ApplicationConfiguration>(
    '/api/abp/application-configuration',
  );
  return data;
}
